import axios from "axios";
import { SERVER_URL } from "./../env";
import articles from "@/store/articles";
import article from "@/store/article";
import user from "@/store/user";
import router from "@/router";

export default {
  state: {
    blogInfo: {},
    years: [],
    settings: {},
    errors: {}
  },

  getters: {
    blogInfo: state => state.blogInfo,
    years: state => state.years,
    settings: state => state.settings,
    errors: state => state.errors
  },

  mutations: {
    setBlogInfo: (state, payload) => {
      state.blogInfo = payload;
    },
    setYears: (state, payload) => {
      state.years = payload;
    },
    setSettings: (state, payload) => {
      state.settings = payload;
    },
    clearErrors: state => {
      state.errors = {};
    },
    pushErrors: (state, payload) => {
      state.errors = payload;
    },
    setErrors: (state, payload) => {
      state.errors = payload;
    }
  },

  actions: {
    setHttpError({ commit }, e) {
      let msg = null;

      if (e.response) {
        const r = e.response;

        if (r.status === 404) {
          router.push("/404");
          msg = null;
        } else if (r.status === 401) {
          router.push("/login");
          msg = null;
        } else if (r.status === 400 && r.data.message) {
          msg = { message: r.data.message };
        } else if (r.status === 400 && r.data.errors) {
          msg = r.data.errors;
        } else {
          msg = {
            message: `Произошла ошибка на сервере с кодом ${r.status}! Пожалуйста, попробуйте позже или обратитесь к администратору`
          };
        }
      } else {
        msg = {
          message:
            "Связь с сервером потеряна! Пожалуйста, попробуйте позже или обратитесь к администратору"
        };
      }
      if (msg) {
        commit("setErrors", msg);
      }
    },
    handleResultFalseError({ commit }, response) {
      if (response.result === false) {
        if (response.message) {
          commit("setErrors", { message: response.message });
        } else if (response.errors) {
          commit("setErrors", response.errors);
        }
      }
    },
    async getBlogInfo({ commit, dispatch }) {
      try {
        const res = await axios.get(`${SERVER_URL}/api/init`);
        commit("setBlogInfo", res.data);
      } catch (e) {
        dispatch("setHttpError", e);
      }
    },
    async getYears({ commit, dispatch }) {
      try {
        const res = await axios.get(`${SERVER_URL}/api/calendar`);
        commit("setYears", res.data.years);
      } catch (e) {
        dispatch("setHttpError", e);
      }
    },

    async getSettings({ commit, dispatch }) {
      try {
        const res = await axios.get(`${SERVER_URL}/api/settings`);
        commit("setSettings", res.data);
      } catch (e) {
        dispatch("setHttpError", e);
      }
    },

    async setSettings({ commit, dispatch }, payload) {
      try {
        await axios.put(`${SERVER_URL}/api/settings`, payload);
        commit("setSettings", payload);
      } catch (e) {
        dispatch("setHttpError", e);
      }
    }
  },

  modules: {
    articles,
    article,
    user
  }
};
